import { HTMLAttributes, PropsWithChildren } from 'react';

import { Styles, css, cx } from '@flipster/styled-system/css';
import { StatusBadgeVariantProps, statusBadge } from '@flipster/styled-system/recipes';

type BaseProps = PropsWithChildren<{
  color?: StatusBadgeVariantProps['color'];
  positionType?: StatusBadgeVariantProps['positionType'];
  visible?: StatusBadgeVariantProps['visible'];
  css?: Styles;
}>;

export type StatusBadgeProps = BaseProps & Omit<HTMLAttributes<HTMLDivElement>, keyof BaseProps>;

export const StatusBadge = ({ positionType, color, visible, children, css: cssProps, ...props }: StatusBadgeProps) => {
  const rootClass = statusBadge({ positionType, color, visible });

  return (
    <div className={cx(rootClass.root, css(cssProps))} {...props}>
      {children}
    </div>
  );
};

StatusBadge.displayName = 'StatusBadge';
